// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"Segments_blockClick_31MHG"};